import { FC } from "react";
import { Tag } from "antd";
import { DynamicLeverEvaluation } from "../../../../types/OrderFormTypes";

const EvaluationTagMap = new Map([
    [DynamicLeverEvaluation.FAVORABLE, { color: "success" }],
    [DynamicLeverEvaluation.NEUTRAL, { color: "warning" }],
    [DynamicLeverEvaluation.NOT_FAVORABLE, { color: "error" }],
    [DynamicLeverEvaluation.NOT_PRESENT, { color: "error" }],
]);

interface EvaluationTagProps {
    value?: DynamicLeverEvaluation;
}

export const EvaluationTag: FC<EvaluationTagProps> = ({ value }) => {
    if (!value) return null;

    const tagType = EvaluationTagMap.get(value);

    return <Tag color={tagType?.color}>{value}</Tag>;
};
